import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar';
import { Loader2 } from 'lucide-react';

const Dashboard = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div 
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: '#FDFBF7' }}
      >
        <Loader2 
          className="h-8 w-8 animate-spin" 
          style={{ color: '#4A6B5D' }}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FDFBF7' }}>
      <Sidebar />
      
      {/* Main Content - responsivo */}
      <main 
        className="min-h-screen transition-all duration-300 md:ml-72 pt-16 md:pt-0 overflow-y-auto"
        data-testid="dashboard-main-content"
      >
        <div className="p-4 md:p-8 pb-24">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
